import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/rem';

  .TopDownDistributionPanel {
    border: 1px solid #dfe4ea;
    border-radius: 8px;
    margin-top: rem(24px);
    padding: rem(20px);
  }

  .TopDownDistributionPanel--loading,
  .TopDownDistributionPanel--error {
    color: #697386;
  }

  .TopDownDistributionPanel__header,
  .TopDownDistributionPanel__section-header,
  .TopDownDistributionPanel__preview-controls,
  .TopDownDistributionPanel__save-policy {
    align-items: center;
    display: flex;
    gap: rem(12px);
    justify-content: space-between;
  }

  .TopDownDistributionPanel__header h3,
  .TopDownDistributionPanel__section-header h4 {
    margin: 0;
  }

  .TopDownDistributionPanel__header p,
  .TopDownDistributionPanel__section-header p,
  .TopDownDistributionPanel__empty {
    color: #697386;
    margin: rem(5px 0 0);
  }

  .TopDownDistributionPanel__summary {
    display: grid;
    gap: rem(12px);
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    margin: rem(20px 0);
  }

  .TopDownDistributionPanel__summary div {
    background: #f7f9fc;
    border-radius: 6px;
    padding: rem(12px);
  }

  .TopDownDistributionPanel__summary dt {
    color: #697386;
    font-size: rem(12px);
  }

  .TopDownDistributionPanel__summary dd {
    font-weight: 600;
    margin: rem(5px 0 0);
  }

  .TopDownDistributionPanel__management,
  .TopDownDistributionPanel__rules,
  .TopDownDistributionPanel__overrides,
  .TopDownDistributionPanel__preview,
  .TopDownDistributionPanel__create,
  .TopDownDistributionPanel__allocations {
    border-top: 1px solid #edf0f4;
    margin-top: rem(18px);
    padding-top: rem(18px);
  }

  .TopDownDistributionPanel__management {
    background: #f7f9fc;
    border-radius: 6px;
    padding: rem(16px);
  }

  .TopDownDistributionPanel__management p {
    color: #697386;
    margin: rem(5px 0 0);
  }

  .TopDownDistributionPanel__management-controls {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: rem(10px);
    margin-top: rem(12px);
  }

  .TopDownDistributionPanel__create-controls {
    align-items: flex-end;
    display: grid;
    gap: rem(10px);
    grid-template-columns: auto minmax(180px, 1fr) auto minmax(180px, 1fr) auto;
    margin-top: rem(18px);
  }

  .TopDownDistributionPanel__rule-list,
  .TopDownDistributionPanel__override-list,
  .TopDownDistributionPanel__preview-result {
    display: grid;
    gap: rem(8px);
    margin-top: rem(12px);
  }

  .TopDownDistributionPanel__rule {
    align-items: center;
    display: grid;
    gap: rem(8px);
    grid-template-columns: auto minmax(65px, 0.4fr) auto minmax(100px, 1fr) auto;
  }

  .TopDownDistributionPanel__override,
  .TopDownDistributionPanel__preview-result > div {
    align-items: center;
    background: #f7f9fc;
    border-radius: 6px;
    display: grid;
    gap: rem(12px);
    grid-template-columns: minmax(140px, 1fr) minmax(100px, 0.5fr) auto;
    padding: rem(10px 12px);
  }

  .TopDownDistributionPanel__override-details,
  .TopDownDistributionPanel__override-path {
    display: flex;
    flex-direction: column;
  }

  .TopDownDistributionPanel__override-path {
    margin-top: rem(5px);
  }

  .TopDownDistributionPanel__override small {
    color: #697386;
    margin-top: rem(3px);
  }

  .TopDownDistributionPanel input,
  .TopDownDistributionPanel select {
    background: #fff;
    border: 1px solid #cbd2dc;
    border-radius: 5px;
    min-height: rem(38px);
    padding: rem(8px 10px);
  }

  .TopDownDistributionPanel__percentage-input {
    align-items: center;
    display: flex;
    position: relative;
  }

  .TopDownDistributionPanel__percentage-input input {
    padding-right: rem(25px);
    width: 100%;
  }

  .TopDownDistributionPanel__percentage-input span {
    color: #697386;
    position: absolute;
    right: rem(9px);
  }

  .TopDownDistributionPanel__remove {
    background: transparent;
    border: 0;
    color: #b42318;
    cursor: pointer;
    font-size: rem(22px);
    padding: rem(4px 8px);
  }

  .TopDownDistributionPanel__preview-controls {
    justify-content: flex-start;
    margin-top: rem(12px);
  }

  .TopDownDistributionPanel__preview-result > div {
    grid-template-columns: minmax(140px, 1fr) auto auto;
  }

  .TopDownDistributionPanel__preview-result .TopDownDistributionPanel__preview-total,
  .TopDownDistributionPanel__preview-result .TopDownDistributionPanel__preview-master {
    background: #eef5ff;
  }

  .TopDownDistributionPanel__preview-result .TopDownDistributionPanel__path-preview {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    grid-column: 1 / -1;
  }

  .TopDownDistributionPanel__message {
    border-radius: 5px;
    margin: rem(14px 0 0);
    padding: rem(10px 12px);
  }

  .TopDownDistributionPanel__message--error {
    background: #fff0ee;
    color: #b42318;
  }

  .TopDownDistributionPanel__message--success {
    background: #e8f7ef;
    color: #16794c;
  }

  .TopDownDistributionPanel__save-policy {
    border-top: 1px solid #edf0f4;
    justify-content: flex-end;
    margin-top: rem(18px);
    padding-top: rem(18px);
  }

  .TopDownDistributionPanel__allocation-warning {
    background: #fff8e7;
    border-radius: 5px;
    color: #8a4b0f;
    margin: rem(12px 0 0);
    padding: rem(10px 12px);
  }

  .TopDownDistributionPanel__allocation-filters {
    align-items: flex-end;
    display: flex;
    flex-wrap: wrap;
    gap: rem(10px);
    margin-top: rem(12px);
  }

  .TopDownDistributionPanel__allocation-filters label {
    align-self: center;
  }

  .TopDownDistributionPanel__allocation-table-wrap {
    margin-top: rem(12px);
    overflow-x: auto;
  }

  .TopDownDistributionPanel__allocation-table {
    border-collapse: collapse;
    min-width: rem(560px);
    width: 100%;
  }

  .TopDownDistributionPanel__allocation-table th,
  .TopDownDistributionPanel__allocation-table td {
    border-bottom: 1px solid #edf0f4;
    padding: rem(10px 8px);
    text-align: left;
    vertical-align: top;
  }

  .TopDownDistributionPanel__allocation-table th {
    color: #697386;
    font-size: rem(12px);
    font-weight: 500;
  }

  .TopDownDistributionPanel__allocation-table td small {
    color: #697386;
    display: block;
    margin-top: rem(3px);
  }

  .TopDownDistributionPanel__allocation-row--negative td:last-child strong {
    color: #b42318;
  }

  .TopDownDistributionPanel__load-more {
    display: flex;
    justify-content: center;
    margin-top: rem(14px);
  }

  @media (max-width: 640px) {
    .TopDownDistributionPanel__header,
    .TopDownDistributionPanel__section-header,
    .TopDownDistributionPanel__preview-controls,
    .TopDownDistributionPanel__save-policy {
      align-items: stretch;
      flex-direction: column;
    }

    .TopDownDistributionPanel__management-controls {
      align-items: stretch;
      flex-direction: column;
    }

    .TopDownDistributionPanel__allocation-filters {
      align-items: stretch;
      flex-direction: column;
    }

    .TopDownDistributionPanel__create-controls {
      align-items: stretch;
      grid-template-columns: 1fr;
    }

    .TopDownDistributionPanel__rule,
    .TopDownDistributionPanel__override,
    .TopDownDistributionPanel__preview-result > div {
      grid-template-columns: 1fr;
    }
  }
`;

export { staticStyles };
